document.addEventListener('DOMContentLoaded', function () {
	//AOS.init({
		//duration: 800,   // Animation duration in ms
	//});

	document.body.matchHeight();

	const path_wrapper = document.querySelector('.path_wrapper');
	const indicator = document.querySelector('.timeline_indicator');

	if (path_wrapper && indicator) {

		function update() {
		    const rect = path_wrapper.getBoundingClientRect();

		    const windowHeight = window.innerHeight;
		    const sectionHeight = path_wrapper.offsetHeight;

		    // START: unchanged (top enters viewport)
		    const start = windowHeight;

		    // END: when bottom hits 50% viewport
		    const end = windowHeight * 0.5 - sectionHeight;

		    let progress = (start - rect.top) / (start - end);

		    progress = Math.max(0, Math.min(progress, 1));

		    const railHeight = path_wrapper.offsetHeight;

		    indicator.style.top = (progress * railHeight) + 'px';
		}

		window.addEventListener('scroll', update, { passive: true });
		window.addEventListener('resize', update);
		update();
	}

	// testimonials carousel

    const testimonials = document.querySelectorAll('#testimonials');

    testimonials.forEach(wrapper => {
        const splideEl = wrapper.querySelector('.splide');
        const prevBtn  = wrapper.querySelector('.testimonial_prev');
        const nextBtn  = wrapper.querySelector('.testimonial_next');

        const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 3;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        arrows: false,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1 },
	        },
	    });

	    splide.mount();

        // External controls
        if (prevBtn) { prevBtn.addEventListener('click', () => splide.go('<')); }
        if (nextBtn) { nextBtn.addEventListener('click', () => splide.go('>')); }
    });

    // testimonials carousel

    const articles = document.querySelectorAll('#related_articles');

    articles.forEach(wrapper => {
        const splideEl = wrapper.querySelector('.splide');
        const prevBtn  = wrapper.querySelector('.article_prev');
        const prevBtnXS  = wrapper.querySelector('.article_prev_xs');
        const nextBtn  = wrapper.querySelector('.article_next');
        const nextBtnXS  = wrapper.querySelector('.article_next_xs');

        const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 3;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        arrows: false,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1 },
	        },
	    });

	    splide.mount();

        // External controls
        if (prevBtn) { prevBtn.addEventListener('click', () => splide.go('<')); }
        if (prevBtnXS) { prevBtnXS.addEventListener('click', () => splide.go('<')); }
        if (nextBtn) { nextBtn.addEventListener('click', () => splide.go('>')); }
        if (nextBtnXS) { nextBtnXS.addEventListener('click', () => splide.go('>')); }
    });

    const progressBar = document.querySelector('.page_progress');

	function updateProgress() {
	  	const scrollTop = window.scrollY;
	  	const docHeight = document.documentElement.scrollHeight - window.innerHeight;

	  	const progress = scrollTop / docHeight;

	  	progressBar.style.width = (progress * 100) + '%';
	}

	window.addEventListener('scroll', updateProgress);


	const filter_config = [
        {
            bodyClass: 'search-results',
            tabId: 'blog_tabs_search',
            widgetId: 'search-2'
        },
        {
            bodyClass: 'date',
            tabId: 'blog_tabs_archive',
            widgetId: 'archives-2'
        },
        {
            bodyClass: 'category',
            tabId: 'blog_tabs_category',
            widgetId: 'categories-2'
        }
    ];

    filter_config.forEach(item => {
        if (document.body.classList.contains(item.bodyClass)) {

            const tab = document.getElementById(item.tabId);
            if (tab) {
                tab.setAttribute('aria-expanded', 'true');
            }

            const widget = document.getElementById(item.widgetId);
            if (widget) {
                widget.classList.add('show');
            }
        }
    });

    document.getElementById('menu_toggle').addEventListener('click', function () {
    	const menu = document.getElementById('lucid_menu');
    	const nav = document.getElementById('main-nav');
    	document.body.classList.toggle('menu_open');
    	const toggle = document.getElementById('menu_toggle');
		menu.classList.toggle('active');
		nav.classList.toggle('menu_open');
		toggle.classList.toggle('active');
	});

	document.querySelectorAll('.alm-load-more-btn').forEach(btn => {
		btn.insertAdjacentHTML('beforeend', '<span class="btn-circle"></span>');
	});

	const modal = document.getElementById('video_player');
	const iframe = document.getElementById('video_frame');
	if (modal) {
		// When modal opens
		modal.addEventListener('show.bs.modal', event => {

			const button = event.relatedTarget;

			if (!button) return;

			const videoSource = button.getAttribute('data-source');
			const videoUrl = button.getAttribute('data-video');
			const modalBody = modal.querySelector('.modal-body');


			if (videoSource === 'Local') {
			    modalBody.innerHTML = `
			      <div class="ratio ratio-16x9">
			        <video controls autoplay playsinline>
			          <source id="video_frame" src="${videoUrl}" type="video/mp4">
			        </video>
			      </div>
			    `;
			  } else {
			    modalBody.innerHTML = `
			      <div class="ratio ratio-16x9">
			        <iframe
			          src="${videoUrl}"
			          id="video_frame"
			          title="Lucid ADHD"
			          allow="autoplay; encrypted-media"
			          allowfullscreen>
			        </iframe>
			      </div>
			    `;
			  }

		});

		// When modal closes
		modal.addEventListener('hidden.bs.modal', () => {
			const modalBody = modal.querySelector('.modal-body');

			modalBody.innerHTML = '';

		});
	}

	// new SlimSelect({
    // 	select: '#inputID',
    // 	settings: {
	// 	    placeholderText: 'PlaceholderText',
	// 	    showSearch: false,
	//   	}
  	// });
});


